(function () {
  let cartDrawer, cartTab, cartItemsContainer, cartTotalEl, cartCountEl;

  function unlockBodyScroll() {
    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove(
      "overflow-hidden",
      "overflow-hidden-mobile",
      "overflow-hidden-tablet",
      "overflow-hidden-desktop"
    );

    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }

  function killDawnCartDrawer() {
    const overlay = document.getElementById("CartDrawer-Overlay");
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }

    const dawnDrawer = document.querySelector("cart-drawer");
    if (dawnDrawer) {
      dawnDrawer.classList.remove("is-open", "active", "animate");
      dawnDrawer.removeAttribute("open");
    }

    unlockBodyScroll();
  }

  function openkeweCartDrawer() {
    if (!cartDrawer) return;
    killDawnCartDrawer();
    cartDrawer.classList.add("is-open");
  }

  function closekeweCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    killDawnCartDrawer();
  }

  function changekeweCartLine(lineKey, quantity) {
    if (quantity < 0 || isNaN(quantity)) quantity = 0;

    return fetch("/cart.js", {
      headers: { Accept: "application/json" }
    })
      .then((response) => {
        if (!response.ok) throw new Error("Unable to load cart");
        return response.json();
      })
      .then((cart) => {
        const formData = new FormData();

        cart.items.forEach((item) => {
          const newQty = item.key === lineKey ? quantity : item.quantity;
          formData.append(`updates[${item.key}]`, Math.max(newQty, 0));
        });

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData
        });
      })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.description || "Error updating cart");
          });
        }
        return response.json();
      })
      .then(() => refreshkeweCart())
      .catch((error) => {
        console.error("Cart change error:", error);
        alert(error.message || "Unable to update cart. Please try again.");
      });
  }

  function attachLineItemHandlers(itemEl) {
    const lineKey = itemEl.getAttribute("data-kewe-cart-line-key");
    const removeBtn = itemEl.querySelector("[data-kewe-cart-remove]");
    const qtyInput = itemEl.querySelector("[data-kewe-cart-qty-input]");
    const decBtn = itemEl.querySelector("[data-kewe-cart-qty-decrease]");
    const incBtn = itemEl.querySelector("[data-kewe-cart-qty-increase]");

    if (!lineKey) return;

    if (removeBtn) {
      removeBtn.addEventListener("click", function () {
        changekeweCartLine(lineKey, 0);
      });
    }

    if (decBtn && qtyInput) {
      decBtn.addEventListener("click", function () {
        const current = parseInt(qtyInput.value, 10) || 0;
        const next = Math.max(current - 1, 0);
        qtyInput.value = next;
        changekeweCartLine(lineKey, next);
      });
    }

    if (incBtn && qtyInput) {
      incBtn.addEventListener("click", function () {
        const current = parseInt(qtyInput.value, 10) || 0;
        const next = current + 1;
        qtyInput.value = next;
        changekeweCartLine(lineKey, next);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener("change", function () {
        let value = parseInt(qtyInput.value, 10);
        if (isNaN(value) || value < 0) value = 0;
        qtyInput.value = value;
        changekeweCartLine(lineKey, value);
      });
    }
  }

  function refreshkeweCart() {
    if (!cartItemsContainer || !cartTotalEl || !cartTab || !cartCountEl) {
      return Promise.resolve();
    }

    return fetch("/cart.js", {
      headers: { Accept: "application/json" }
    })
      .then((response) => {
        if (!response.ok) throw new Error("Unable to load cart");
        return response.json();
      })
      .then((cart) => {
        cartCountEl.textContent = cart.item_count || 0;

        if (cart.item_count > 0) {
          cartTab.classList.add("is-visible");
        } else {
          cartTab.classList.remove("is-visible");
        }

        cartItemsContainer.innerHTML = "";

        if (!cart.items || !cart.items.length) {
          cartItemsContainer.innerHTML = '<p class="kewe-cart-empty">Your cart is empty.</p>';
        } else {
          cart.items.forEach((item) => {
            const itemEl = document.createElement("div");
            itemEl.className = "kewe-cart-item";
            itemEl.setAttribute("data-kewe-cart-line-key", item.key);

            const price = (item.line_price / 100).toFixed(2);

            itemEl.innerHTML =
              '<div class="kewe-cart-item-wrapper">' +
                '<div class="kewe-cart-item-image-wrapper">' +
                  '<div class="kewe-cart-item-main"></div>' +
                  (item.variant_title
                    ? `<p class="kewe-cart-item-variant-title">${item.variant_title}</p>`
                    : "") +
                '</div>' +
                '<div class="kewe-cart-item-content">' +
                  `<p class="kewe-cart-item-title">${item.product_title}</p>` +
                  '<button type="button" class="kewe-cart-remove" data-kewe-cart-remove aria-label="Remove item">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">' +
                      '<path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>' +
                    '</svg>' +
                  '</button>' +
                  '<div class="kewe-cart-item-details">' +
                    '<div class="kewe-cart-item-quantity-wrapper">' +
                      '<div class="kewe-cart-item-qty-controls">' +
                        '<button type="button" class="kewe-cart-qty-btn" data-kewe-cart-qty-decrease aria-label="Decrease quantity">' +
                          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">' +
                            '<path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/>' +
                          '</svg>' +
                        '</button>' +
                        `<input type="number" min="0" class="kewe-cart-qty-input" data-kewe-cart-qty-input value="${item.quantity}">` +
                        '<button type="button" class="kewe-cart-qty-btn" data-kewe-cart-qty-increase aria-label="Increase quantity">' +
                          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">' +
                            '<path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/>' +
                          '</svg>' +
                        '</button>' +
                      '</div>' +
                    '</div>' +
                    `<div class="kewe-cart-item-price">$${price}</div>` +
                  '</div>' +
                '</div>' +
              '</div>';

            const mainEl = itemEl.querySelector(".kewe-cart-item-main");
            if (mainEl && item.image) {
              mainEl.style.backgroundImage = `url(${item.image})`;
            }

            cartItemsContainer.appendChild(itemEl);
            attachLineItemHandlers(itemEl);
          });
        }

        cartTotalEl.textContent = `$${(cart.total_price / 100).toFixed(2)}`;
      })
      .catch((error) => {
        console.error("Cart load error:", error);
      });
  }

  function bindCartTriggers() {
    cartDrawer = document.querySelector("[data-kewe-cart-drawer]");
    cartTab = document.querySelector("[data-kewe-cart-tab]");
    cartItemsContainer = document.querySelector("[data-kewe-cart-items]");
    cartTotalEl = document.querySelector("[data-kewe-cart-total]");
    cartCountEl = document.querySelector("[data-kewe-cart-count]");

    if (!cartDrawer || !cartTab) return;

    const closeBtn = cartDrawer.querySelector(".kewe-cart-drawer-close");

    cartTab.addEventListener("click", function () {
      if (cartDrawer.classList.contains("is-open")) {
        closekeweCartDrawer();
      } else {
        openkeweCartDrawer();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closekeweCartDrawer);
    }

    cartDrawer.addEventListener("click", function (event) {
      if (event.target === cartDrawer) {
        closekeweCartDrawer();
      }
    });

    document.addEventListener("click", function (event) {
      const trigger = event.target.closest(
        'a[href="/cart"], button[href="/cart"], .header__icon--cart, #cart-icon-bubble'
      );

      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openkeweCartDrawer();
      refreshkeweCart();
    }, true);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && cartDrawer.classList.contains("is-open")) {
        closekeweCartDrawer();
      }
    });

    refreshkeweCart();
    killDawnCartDrawer();
  }

  document.addEventListener("submit", function (event) {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    const formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.description || "Error adding to cart");
          });
        }
        return response.json();
      })
      .then(() => refreshkeweCart())
      .then(() => openkeweCartDrawer())
      .catch((error) => {
        console.error("Add to cart error:", error);
        alert(error.message || "Unable to add to cart. Please try again.");
      });
  }, true);

  document.addEventListener("DOMContentLoaded", function () {
    bindCartTriggers();
  });
})();